import "./navbar.css"
import "./global.css"
import anime from "animejs";
export default function NavBar(){
    document.addEventListener("DOMContentLoaded", function() { 
        window.onload = () => { 
    var cursorto = document.querySelector('.cursor');
          var linkbigup = document.querySelectorAll('.anim-div');

          linkbigup.forEach(function(element) {
            element.addEventListener('mouseenter', (event) => {
              anime({
                targets: cursorto,
                scale: 6,
                easing: 'easeInOutSine',
                duration: 100,
              });
            });

            element.addEventListener('mouseleave', (event) => {
              anime({
                targets: cursorto,
                scale: 1,
                easing: 'easeInOutSine',
                duration: 100,
              });
            });
          });
        }
    });



    function openNav(slide,svgimg,sidelink,cursor) {
        anime({
            targets: slide,
            width: ['0vw', '100vw'],
            easing: 'easeInOutQuad',
            duration: 300,
            complete: function(cursorcolor){
                cursor.style.backgroundColor = '#fff';
            }
          });
        anime({
            targets: svgimg,
            fill: '#fff', // Anima l'opacità da 0 a 1
            easing: 'easeInOutQuad',
            duration: 500,
          });
        anime({
            targets: sidelink,
            opacity: [0,1], // Anima l'opacità da 0 a 1
            easing: 'easeInOutQuad',
            delay: 200,
            duration: 100,
          });
        
    }

    // Funzione per chiudere il menu
    function closeNav(slide,svgimg,sidelink,cursor) {
        anime({
            targets: slide,
            width: ['100vw', '0vw'],
            easing: 'easeInOutQuad',
            duration: 300,
            complete: function(cursorcolor){
                cursor.style.backgroundColor = '#fff';
                
            }
          });
          anime({
            targets: svgimg,
            fill: '#1b1b1b', // Anima l'opacità da 0 a 1
            easing: 'easeInOutQuad',
            delay: 300,
            duration: 200,
          });
          anime({
            targets: sidelink,
            opacity: [1,0], // Anima l'opacità da 0 a 1
            easing: 'easeInOutQuad',
            delay: 200,
            duration: 100,
          });
          
    }
    const togglefunction = () => {
        var slide = document.getElementById("sideMenu");
            var checkbox = document.getElementById('checkbox');
            var svgimg = document.querySelector('.nb-logo svg path')
            var sidelink = document.querySelectorAll('.side-drawer a')
            var cursor = document.querySelector('.cursor');
            if (checkbox.checked === false) {
                openNav(slide,svgimg,sidelink,cursor); // Se il checkbox è selezionato, apri il menu
                document.body.classList.add('no-scroll');
                //cursor.style.backgroundColor = 'white'; -- PRESTAZIONI
                
            } else {
                closeNav(slide,svgimg,sidelink,cursor); // Se il checkbox non è selezionato, chiudi il menu
                document.body.classList.remove('no-scroll');
                //cursor.style.backgroundColor = '#1b1b1b'; -- PRESTAZIONI
            }
    };


   return(
    <div className="navbar">
        <div className="nb-logo">
        {/* https://concorsomarconi2.iti-marconi.edu.it/ */}
                <svg width="64" height="70" viewBox="0 0 48 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M39.6214 4.73262C37.8159 4.73262 36.5224 5.67578 36.5224 7.83157C36.5224 11.6581 47.1127 15.1343 47.1127 19.2842C47.1127 22.5718 43.0706 24.4042 39.5675 24.4042C36.738 24.4042 34.0163 23.2455 32.8845 22.1406L34.3397 16.9128H34.663C34.69 21.2514 36.8997 24.1347 39.8908 24.1347C41.8041 24.1347 43.7174 23.0029 43.7174 20.8741C43.7174 16.6434 33.2348 13.6791 33.2348 8.90947C33.2348 6.10694 36.2799 4.46315 39.6483 4.46315C42.5586 4.46315 45.3881 5.64883 46.5199 6.75368L45.1725 12.0084H44.8492C44.8761 7.75073 42.6664 4.73262 39.6214 4.73262Z M15.9561 24.6072L15.8694 24.3469C16.2742 24.1156 16.6789 23.5808 17.0837 22.7423C18.7028 19.562 20.2351 16.1648 21.6808 12.5507C23.1264 8.93669 24.4274 5.46722 25.5839 2.14231C25.6417 1.99775 25.6851 1.8821 25.714 1.79536C25.7429 1.67971 25.7574 1.59298 25.7574 1.53515C25.7574 1.30385 25.4104 1.17375 24.7165 1.14484C24.0226 1.14484 23.2854 1.1882 22.5048 1.27494C22.4469 1.27494 22.418 1.24603 22.418 1.1882C22.418 1.10147 22.4469 1.01473 22.5048 0.927994C22.5626 0.841257 22.6204 0.812344 22.6782 0.841256C23.1408 0.870167 23.6179 0.899081 24.1094 0.927994C24.6009 0.927994 25.1069 0.927994 25.6273 0.927994C25.9453 0.927994 26.2634 0.927994 26.5814 0.927994C26.9283 0.927994 27.2608 0.913538 27.5789 0.884624C27.9836 0.855712 28.3739 0.841256 28.7498 0.841256C29.1546 0.841256 29.5449 0.841256 29.9208 0.841256C30.2099 0.841256 30.4845 0.841256 30.7448 0.841256C31.0339 0.841256 31.323 0.855712 31.6121 0.884624C33.9829 1.00027 35.8767 1.46287 37.2934 2.27241C38.739 3.08196 39.7798 4.10835 40.4159 5.35157C41.052 6.56589 41.37 7.89585 41.37 9.34147C41.37 10.8738 41.0664 12.4351 40.4593 14.0253C39.8521 15.6154 39.0281 17.09 37.9873 18.4488C36.9464 19.7788 35.7755 20.8775 34.4744 21.7448C32.7686 22.8724 31.1495 23.5952 29.6172 23.9133C28.1137 24.2313 26.6103 24.3903 25.1069 24.3903C24.2973 24.3903 23.4878 24.3759 22.6782 24.3469C21.8687 24.318 21.0447 24.3036 20.2062 24.3036C19.5412 24.3036 18.8474 24.318 18.1245 24.3469C17.4306 24.3759 16.7078 24.4626 15.9561 24.6072ZM24.2829 24.0867C26.0176 24.0867 27.7379 23.8699 29.4437 23.4362C31.1495 23.0025 32.7252 22.2508 34.1709 21.181C35.2984 20.3426 36.2959 19.2728 37.1633 17.9718C38.0596 16.6418 38.7535 15.2251 39.245 13.7217C39.7654 12.1893 40.0256 10.7003 40.0256 9.25473C40.0256 7.7802 39.722 6.43578 39.1149 5.22147C38.5366 3.97824 37.597 2.99522 36.2959 2.27241C34.9949 1.5207 33.2457 1.14484 31.0483 1.14484C30.7303 1.14484 30.2966 1.14484 29.7473 1.14484C29.1979 1.11592 28.6775 1.15929 28.186 1.27494C27.6945 1.39059 27.3476 1.62189 27.1452 1.96884C26.1043 3.81922 25.0924 5.84308 24.1094 8.04041C23.1553 10.2377 22.2445 12.464 21.3772 14.7192C20.5098 16.9454 19.6858 19.056 18.9052 21.0509C18.7317 21.4846 18.6016 21.8605 18.5149 22.1785C18.457 22.4676 18.4281 22.6989 18.4281 22.8724C18.4281 23.1326 18.4859 23.3061 18.6016 23.3928C18.7462 23.4796 18.9341 23.5519 19.1654 23.6097C19.9749 23.7542 20.7989 23.8699 21.6374 23.9566C22.5048 24.0434 23.3866 24.0867 24.2829 24.0867Z M7.76645 24H0.86792V23.7305C2.6195 23.7305 3.77824 23.3263 3.96687 20.5777L4.80224 5.83747C4.45192 5.568 3.91297 5.40631 3.05066 5.40631V5.13684H8.27845L13.6949 19.3651L18.3837 5.13684H23.9888V5.40631C22.1833 5.40631 21.7521 5.67579 21.806 6.34947L23.1534 22.7874C23.2073 23.488 24.0157 23.7305 25.3361 23.7305V24H18.0334V23.7305C19.3538 23.7305 19.8658 23.4611 19.8119 22.7874L18.5723 7.40042L12.2128 24H11.9163L5.20645 6.40337C5.1795 6.29558 5.1256 6.21474 5.07171 6.10695L4.82918 20.5777C4.80224 23.3263 6.01487 23.7305 7.76645 23.7305V24Z" fill="#1b1b1b"/>

                </svg>
        </div>
        <input id="checkbox" type="checkbox"/>
            <label className="toggle" for="checkbox" onClick={togglefunction}>
                <div id="bar1" class="bars"></div>
                <div id="bar2" class="bars"></div>
                <div id="bar3" class="bars"></div>
            </label>
        
            <div id="sideMenu" class="side-drawer">
                <a className="anim-div anim-trigger-link" href="https://drive.google.com/file/d/1_VOPiLY45hndk2guxNsvJYYMFhJ-T_z8/view">Bando</a>
            </div>
            
        
    </div>
   );
   
}